import { Component } from '@angular/core';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { Router } from '@angular/router';
import { SidebarService } from '../services/sidebar.service';
import { SidebarLink } from 'src/app/core/interfaces/sidebar';
import { UsersService } from 'src/app/data/services/users.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {

  sidebarLinks: SidebarLink[] = [];

  constructor(
    public sidebarService: SidebarService,
    public authService: AuthService,
    public router: Router,
    private userService: UsersService
    ) {}

    ngOnInit(): void {
      this.sidebarLinks = this.sidebarService.getSidebarLinks();
      this.userService.user$.subscribe(user => {
        this.sidebarLinks = this.sidebarService.getSidebarLinks();
      });
    }

    openSidebar(): void {
      this.sidebarService.open();
    }
    closeSidebar(): void {
      this.sidebarService.close();
    }

    isCurrentPage(link: string): boolean {
      return this.router.url.startsWith(link)
    }

    navigate(link: string): void {
      if (this.isCurrentPage(link)) {
        window.location.reload();
      } else {
        this.router.navigateByUrl(link);
      }
    }

}
